import { protectedFetchReq } from '../../helpers/requestHelper';

const protectedPaymentRequest = (endpoint, body) => async dispatch => {
    try {
        return await protectedFetchReq(endpoint, body, 'POST', dispatch) || {
            status: false,
            msg: 'invalid-token'
        };
    } catch (error) {
        return { status: false, msg: 'request-err' };
    }
};

export const retryUserOrderPayment = (provider, orderId) => protectedPaymentRequest(
    'account/payment/retry',
    { _id: orderId, provider }
);

export const checkUserOrderPaymentStatus = (orderId, dispatch) => protectedFetchReq(
    'account/payment/order-status',
    { _id: orderId },
    'POST',
    dispatch
).catch(() => ({ status: false, msg: 'request-err' }));

export const reconcileUserOrderPayment = (orderId, dispatch) => protectedFetchReq(
    'account/payment/order-reconcile',
    { _id: orderId },
    'POST',
    dispatch
).catch(() => ({ status: false, msg: 'request-err' }));
